import React, { Fragment } from 'react'
import { Media, Icon } from 'easyguide'
import { compose, lifecycle, withHandlers, withState } from 'recompose'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import MediaRouter from 'react-media'
import backIcon from 'assets/backIcon.svg'
import PendencyAlert from '@easynvest/pendency-alert'
import { MenuBarComponent } from 'easycommons/modules/MenuBar'
import { getFeatureToggle } from 'store/reducers/featureToggle'
import { PENDENCY_TYPES } from 'config/constants'
import {
  Wrapper,
  BackButton,
  LogoWrapper,
  MobileHeader,
  WrapperContent,
  ContentWrapper,
  SidebarComponent,
  ContentComponent,
  ExternalContentWrapper
} from './Template.style'
import logoUrl from '../../assets/logo.svg'

const enhance = compose(
  connect(({ content, pendency }) => ({ content, pendency }), {
    getFeatureToggleConnect: getFeatureToggle
  }),
  withRouter,
  withHandlers({
    setActiveItem: () => (pathname, obj) => (/ajuda/.test(pathname) ? obj.HELP : obj.SETTINGS)
  }),
  withState('small', 'setSmall', window.innerWidth <= Media.sizes.mobile),
  lifecycle({
    componentDidMount() {
      document.querySelector('.loading').classList.add('hide')
      this.props.getFeatureToggleConnect()
    }
  })
)
/* eslint-disable react/prop-types*/
const Template = ({ history, content, children, setActiveItem, pathname, pendency, small }) => {
  const { pendencies, status } = pendency
  const hasPendency = (pendencies || []).length
  const isStatusPendencyAnalize = status === PENDENCY_TYPES.ANALYZE
  const showPendencies = hasPendency || isStatusPendencyAnalize

  if (showPendencies) {
    const pendencyTypes = pendencies.map(currentPendency => currentPendency.type)
    PendencyAlert(pendencyTypes.length > 0 ? pendencyTypes : [''], status)
  }
  return (
    <Wrapper small={small}>
      <MenuBarComponent
        autoresolve
        activeItem={setActiveItem(pathname, MenuBarComponent.items)}
      />
      {content.showSideBar && (
        <WrapperContent>
          <MediaRouter query={{ maxWidth: Media.sizes.mobile }}>
            {screenIsSmall =>
              screenIsSmall ? (
                <ContentComponent>
                  {history.location.pathname !== '/' && (
                    <MobileHeader>
                      <BackButton onClick={() => history.push('/')}>
                        <Icon width="23px" height="23px" url={backIcon} />
                      </BackButton>
                      <LogoWrapper>
                        <Icon width="147px" height="28px" url={logoUrl} />
                      </LogoWrapper>
                    </MobileHeader>
                  )}
                  <ContentWrapper>{children}</ContentWrapper>
                </ContentComponent>
              ) : (
                <Fragment>
                  <SidebarComponent pendency={pendency} />
                  <ContentComponent>
                    <ContentWrapper>{children}</ContentWrapper>
                  </ContentComponent>
                </Fragment>
              )
            }
          </MediaRouter>
        </WrapperContent>
      )}
      {!content.showSideBar && (
        <ExternalContentWrapper>
          {children}
        </ExternalContentWrapper>
      )}
    </Wrapper>
  )
}

export default enhance(Template)
